import './loading.css'
import loadingicon from '../../image/loading.gif'
export default function Loading(props) {
    return(
        <div className='loadingpage' style={props.loading === true ? {display: 'flex'} : {display: 'none'}}>
            <div className='loadingbox'>
                <img src={loadingicon} loading='lazy' alt='loading'></img>
                <div className='loadingdetailsbox'>
                    <h2>تهران مو</h2>
                    <div className='loadinglinebox'>
                        <div className='loadinganimation' style={{width: `${props.loadingnumber}%`}}></div>
                    </div>
                    <div className='loadingnumber'><p>{props.loadingnumber}%</p></div>
                </div>
            </div>
            <p className='versionnumber'>version 1.3.3</p>
        </div>
    )
}